export const environment = {
  // API_URL:'http://localhost:3002/',
  API_URL:'https://dev-api.reconease.ai/',
  RAZORPAY_KEY: 'rzp_test_NsFwfri7NFQFXJ'
};
